import React, { SVGAttributes } from 'react';

interface Props extends SVGAttributes<SVGSVGElement> {
  color?: string;
}

const OcHighlightCard = ({ ...props }: Props) => (
  <>
    <svg
      width="213"
      height="107"
      viewBox="0 0 213 107"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.33008 63.4918C5.97528 68.682 20.2608 74.7389 40.6665 58.2339C41.0576 57.9175 41.6594 58.184 41.6679 58.6869C41.888 71.6608 45.9737 92.1903 76.7186 93.867C90.0244 94.5926 100.275 85.6675 89.375 79.7566C74.5415 71.713 59.3817 111.667 76.902 130.574"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M51.5746 3.17813C55.393 1.21475 59.7486 0.553961 63.9775 1.29651C68.2063 2.03906 72.0763 4.14421 74.9974 7.29096C77.9184 10.4377 79.7302 14.4534 80.1565 18.7258C80.583 22.9981 79.6004 27.2926 77.3587 30.9546C75.1171 34.6165 71.7394 37.4448 67.7407 39.0084C63.7419 40.5721 59.3415 40.785 55.2106 39.6149C51.0795 38.4448 47.4445 35.9557 44.8598 32.5273C42.275 29.099 40.8823 24.9194 40.8941 20.6259L60.5739 20.6799L51.5746 3.17813Z"
        stroke="white"
      />
      <path
        d="M37.3301 18.5104C37.3301 14.9525 38.3139 11.4645 40.1719 8.43499C42.03 5.40546 44.6893 2.95338 47.8535 1.35193L56.4676 18.5104H37.3301Z"
        fill="white"
      />
      <rect
        x="98.9626"
        y="32.6223"
        width="97.9238"
        height="61.7206"
        rx="2.67572"
        transform="rotate(-18.4495 98.9626 32.6223)"
        stroke="white"
      />
      <circle
        cx="111.387"
        cy="38.8306"
        r="2.38179"
        transform="rotate(-18.4495 111.387 38.8306)"
        fill="white"
      />
      <path
        d="M186.007 56.2856L200.618 51.4113M192.458 58.6532L201.975 55.4781"
        stroke="white"
        strokeLinecap="round"
      />
      <path
        d="M122.089 65.8596C125.256 64.4725 133.664 63.8618 142.15 72.3801C142.242 72.4731 142.405 72.4245 142.424 72.2947C144.249 60.0991 147.01 47.1046 172.424 53.364C172.584 53.4034 172.713 53.2057 172.595 53.0903C166.772 47.3677 159.502 33.7841 173.635 21.4938C173.749 21.3948 173.682 21.2001 173.532 21.2058L167.612 21.4287C167.441 21.4351 167.383 21.2112 167.537 21.1384C171.422 19.3015 178.285 17.0968 177.018 20.3971C175.644 23.9726 175.668 25.9356 177.208 28.6764"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  </>
);

export default OcHighlightCard;
